import { Slide } from '@features/powerpoint';
import { ImageWithMetadata } from '@features/powerpoint';
import { texts } from './campaign-overview-2/texts';
import { buildDriverTextsOptions } from './campaign-overview-2/driver-texts';
import { ValueInput } from '@utils/formattersV2';
import { buildCampaignOverviewSlide2 } from '@features/executive-report/slides/campaign-overview-2/campaign-overview-2';
import { shapes } from '@features/executive-report/slides/campaign-overview-2/shapes';
import { driverShapes } from './campaign-overview-2/shapes';
import { RslReport } from '@features/campaigns/subdomains/rsl';

const DRIVER_OFFSET = 1.36;

export type CampaignOverviewSlide2Options = {
  brandLogoWithMetadata: ImageWithMetadata | null;
  report: RslReport;
  iroas: ValueInput;
  objectives: string[];
};

export const campaignOverviewSlide2 = (
  options: CampaignOverviewSlide2Options
): Slide => {
  const driverTextsOptions = buildDriverTextsOptions(options.report).map(
    (driverTextsOptions, index) => ({
      ...driverTextsOptions,
      index,
    })
  );

  const driverValues = driverTextsOptions.map(options => options.value ?? 0);

  return buildCampaignOverviewSlide2(
    options.brandLogoWithMetadata,
    texts({
      ...options,
      driverTextsOptions,
    }),
    shapes(
      driverValues.flatMap((value, i) => driverShapes(i, DRIVER_OFFSET, value)),
      options.report.incrementalSalesLift ?? 0
    )
  );
};
